import { render, staticRenderFns } from "./mss-hyrox-description.component.vue?vue&type=template&id=0582a1a9"
import script from "./mss-hyrox-description.component.ts?vue&type=script&lang=ts&external"
export * from "./mss-hyrox-description.component.ts?vue&type=script&lang=ts&external"
import style0 from "./mss-hyrox-description.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports